export default __webpack_public_path__ + "static/media/SomaCapital.2b319978.svg";